export enum WorkflowRunStatusType {
  SUCCESS = 'success',
  ERROR = 'failed',
  READY = 'ready',
  PROCESSING = 'processing',
}
